export const getFlagEmoji = (countryCode: string) => {
  const codePoints = countryCode
    .toUpperCase()
    .split("")
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

export function truncate(text: string, length = 20) {
  if (text.length <= length) {
    return text;
  }
  return text.slice(0, length) + "...";
}

export function getInitials(name: string) {
  return name
    ?.split(" ")
    .filter(Boolean)
    .map((part) => part[0]?.toUpperCase())
    .slice(0, 2)
    .join("");
}

/* ---------------- Badge Color ---------------- */

export const getBadgeColor = (type: string) => {
  switch (type.toLowerCase()) {
    case "public":
      return "bg-[#417DF5]";
    case "private":
      return "bg-[#E68917]";
    case "government":
      return "bg-[#10b981]";
    case "international":
      return "bg-[#f59e0b]";
    case "campus":
      return "#44aa82";
    case "cnline":
      return "#5c8aff";
    case "hybrid":
      return "#b577ed";
    default:
      return "bg-[#6b7280]";
  }
};

export const formatPrice = (
  price: number | string,
  currency: "INR" | "USD" | string = "INR"
) => {
  if (price === null || price === undefined || price === "") return "0";

  const amount = Number(price);
  if (Number.isNaN(amount)) return "0";

  const formatter = new Intl.NumberFormat(
    currency === "INR" ? "en-IN" : "en-US",
    {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }
  );
  return formatter.format(amount);
};

export const getFileTypeColor = (type: string) => {
  if (!type) return "bg-gray-500";

  switch (type.toUpperCase()) {
    case "PDF":
      return "bg-[#fb3748]";
    case "JPG":
    case "JPEG":
    case "PNG":
      return "bg-[#ff8447]";
    case "XLSX":
    case "XLS":
      return "bg-[#1d6f42]";
    case "DOC":
    case "DOCX":
      return "bg-[#2b579a]";
    default:
      return "bg-gray-500";
  }
};
